module.exports = __webpack_public_path__ + "static/media/visa_credit.4c31ce7f.png";